import {
    buildActionCreators,
    makeActionTypes,
    makeAsyncEvents,
} from '../../common/helpers/ReduxHelpers';

import { DOMAIN } from './OrganizationDetails.constants';

export const events = {};

export const asyncEvents = makeAsyncEvents(['fetchDetails', 'update'], true);

export const types = makeActionTypes([...Object.keys(events), ...Object.keys(asyncEvents)], DOMAIN);

export default buildActionCreators(
    {
        ...events,
        ...asyncEvents,
    },
    types
);
